import { get as getUser } from 'js/lib/user';

import localStorageEx from 'bundles/common/utils/localStorageEx';

export const COURSE_FRAME_DESKTOP_NAV_STATE_KEY = 'courseFrameDesktopNavOpen';

type DesktopNavState = { [courseId: string]: boolean } | undefined;

export const getCourseFrameDesktopNavStateKey = () => {
  const userId = getUser().id;
  return `${userId}.courseFrameDesktopNavOpen`;
};

/**
 * Gets the desktop nav state from storage for a given course id.
 * @param courseId - The course id to get the desktop nav state for.
 * @returns The desktop nav state for the given course id.
 */
export const getIsDesktopNavOpenFromStorage = (courseId: string): boolean => {
  try {
    const keyName = getCourseFrameDesktopNavStateKey();
    const desktopNavState: DesktopNavState = localStorageEx.getItem(keyName, JSON.parse, {});
    return desktopNavState?.[courseId] ?? true;
  } catch {
    // Gracefully fallback to default open state if there's any error
    return true;
  }
};

/**
 * Saves the desktop nav state to storage for a given course id.
 * @param courseId - The course id to save the desktop nav state for.
 * @param isOpen - The desktop nav state to save.
 */
export const saveIsDesktopNavOpenToStorage = (courseId: string, isOpen: boolean) => {
  const keyName = getCourseFrameDesktopNavStateKey();
  const desktopNavState: DesktopNavState = localStorageEx.getItem(keyName, JSON.parse, {});
  localStorageEx.setItem(keyName, { ...desktopNavState, [courseId]: isOpen }, JSON.stringify);
};

type ItemToolPanelStorageKeyOptions = {
  userId: string;
  courseId: string;
};

export const getItemToolPanelStorageKey = ({ userId, courseId }: ItemToolPanelStorageKeyOptions): string => {
  const sanitizedUserId = userId || 'anonymous';
  const sanitizedCourseId = courseId || 'unknownCourse';
  return `itemToolPanel:v1:${sanitizedUserId}:${sanitizedCourseId}`;
};
